export default (
  x0: undefined | number,
  x1: undefined | number,
  y0: undefined | number,
  y1: undefined | number,
  xDomain: number[],
  yDomain: number[],
  align: 'start' | 'end',
): [
  number,
  number,
  number,
  number,
  [number, number],
  [number, number],
] => {

  let xLinearDomain: [number, number] = [xDomain[0], xDomain[xDomain.length - 1]];
  let yLinearDomain: [number, number] = [yDomain[0], yDomain[yDomain.length - 1]];

  if (xLinearDomain[0] === xLinearDomain[1]) {
    xLinearDomain = [0, 1];

    if (y0 === y1) {
      [x0, x1] = xLinearDomain;
    }
  }

  if (yLinearDomain[0] === yLinearDomain[1]) {
    yLinearDomain = [0, 1];

    if (x0 === x1) {
      [y0, y1] = yLinearDomain;
    }
  }

  if (x0 === undefined || x1 === undefined) {
    x0 = align === 'start' ? xLinearDomain[0] : xLinearDomain[1];
    x1 = align === 'start' ? xLinearDomain[0] : xLinearDomain[1];
  }

  if (y0 === undefined || y1 === undefined) {
    y0 = align === 'start' ? yLinearDomain[0] : yLinearDomain[1];
    y1 = align === 'start' ? yLinearDomain[0] : yLinearDomain[1];
  }

  return [x0, x1, y0, y1, xLinearDomain, yLinearDomain];
};
